import React from 'react';
import { AdminSection, TeacherSection, Segment } from '../models/timeline';
import FlexBuilderSegment from './FlexBuilderSegment';

const ConditionalFlexOptionWrapper = ({
  FlexOptionComponent,
  segment,
  children,
  openModal,
  timelineId,
}: {
  FlexOptionComponent: React.ComponentType<React.ComponentProps<typeof FlexBuilderSegment>>;
  segment: Segment;
  children: (props: {
    segment: Segment;
    sections: (AdminSection | TeacherSection)[];
    timelineClassName?: string;
  }) => React.ReactNode;
  openModal: (modal: string, params: any) => void;
  timelineId: string;
}) => {
  const { options, sections } = segment;

  if (!segment.isFlex && !options?.length) return children({ segment, sections });

  if (!options?.length) return null;
  return (
    <FlexOptionComponent options={options} openModal={openModal} timelineId={timelineId}>
      {children}
    </FlexOptionComponent>
  );
};

export default ConditionalFlexOptionWrapper;
